import React from "react";
import clsx from "clsx";

export const BackgroundImage = ({ slicePrimary, className, children }) => {

  const bgStyles = {};
  if (slicePrimary?.background_color) {
    bgStyles.backgroundColor = slicePrimary.background_color;
  }

  if (slicePrimary?.background_image?.url) {
    bgStyles.backgroundImage = `url(${slicePrimary.background_image.url})`;
    bgStyles.backgroundRepeat = "no-repeat";
    bgStyles.backgroundSize = "cover";
    bgStyles.backgroundPosition = "center";
  }

  return (
    <div className={clsx(className)} style={bgStyles}>
      {children}
    </div>
  );
};